import { formatSeparateLineItemPerEachInventoryItem } from '../formatSeparateLineItemPerEachInventoryItem'

export const formatQuantitySubAllocationLineItems = ({ inventory, values, right, campaignId, currency }) => {
  const billingEvent = right?.billing_event

  const inventoryFilledWithMicroAmount = inventory.map(placement => {
    const microAmount = placement.prices[billingEvent] || 0

    return {
      ...placement,
      microAmount
    }
  })

  const formattedLineItems = formatSeparateLineItemPerEachInventoryItem({
    values,
    formattedInventory: inventoryFilledWithMicroAmount,
    right,
    campaignId,
    currency
  })

  return formattedLineItems
}
